import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	placeholder: {
		id: 'servicedesk-insight-attribute-views.opsgenie-team.placeholder',
		defaultMessage: 'No Opsgenie Team selected',
		description: 'Message displayed when there are no Opsgene Team selected for an attribute',
	},
	errorTitle: {
		id: 'servicedesk-insight-attribute-views.opsgenie-team.error-title',
		defaultMessage: 'Failed to load Opsgenie Team',
		description: 'Title for the error message when owner fails to load',
	},
	errorMessage: {
		id: 'servicedesk-insight-attribute-views.opsgenie-team.error-message',
		defaultMessage: 'Something went wrong. Please try again.',
		description: 'Message for the error message when owner fails to load',
	},
});
